import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { getLocalizedPricing } from '../lib/util/money';
import * as types from '../types';
import { FREE_TRIAL_SHIPPING_CODE } from '../types/Product';

/**
 * Returns the free trial shipping price in cents for use in calculations.
 */
export default function useFreeTrialShippingPriceInCents(): number {
  const { currency } = useLocale();
  const shippingOptions = useSelector((state: types.AppState) => state.config.shippingOptions);

  const freeTrialShippingOption = shippingOptions.find((option) => option.code === FREE_TRIAL_SHIPPING_CODE);

  if (!freeTrialShippingOption) {
    return 0;
  }

  return getLocalizedPricing(freeTrialShippingOption.pricingInCents, currency);
}
